<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title ">Filtros</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.type_profile_id != null}">
                                        <label for="type_profiles" class="bmd-label-floating">Tipos de Perfil</label>
                                        <multi-select
                                            v-model="form.type_profile_id"
                                            placeholder="Selecione os Tipos de Perfis"
                                            label="name"
                                            track-by="name"
                                            value="id"
                                            :options="type_profiles"
                                            :multiple="true"
                                            :clear-on-select="false"
                                            :preserve-search="true">
                                        </multi-select>
                                        <label v-if="validation.type_profile_id != null" id="type_profile_id-error" class="error" for="type_profile_id">{{ validation.type_profile_id }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="administrator_id" class="bmd-label-floating">Administradora</label>
                                        <model-list-select
                                            class="form-control"
                                            placeholder="Todas"
                                            :list="administrators"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.administrator_id">
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="team_id" class="bmd-label-floating">Equipe</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="teams"
                                            placeholder="Todas"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.team_id"
                                            @input="handlerChangeTeams">
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="team_id" class="bmd-label-floating">Vendedor</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="salesmans"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.salesman_id"
                                            @input="handlerChangeSalesman">
                                        </model-list-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_at != null}">
                                        <label for="interval" class="bmd-label-floating">Intervalo</label>
                                        <date-picker
                                            range
                                            v-model="form.date_at"
                                            lang="pt-br"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha uma data"
                                            >
                                        </date-picker>
                                        <label v-if="validation.date_at != null" id="date_at-error" class="error" for="date_at">{{ validation.date_at }}</label>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_by != null}">
                                        <label for="type_filter_date" class="bmd-label-floating">Filtar data por</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="dates"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.date_by">
                                        </model-list-select>
                                        <label v-if="validation.date_by != null" id="date_by-error" class="error" for="date_by">{{ validation.date_by }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="form.salesman_id != null">
                                <div class="col-md-10">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': extra_reward.name != ''}">
                                        <label for="extra_reward_name" class="bmd-label-floating">Descrição Premiação Extra</label>
                                        <input id="extra_reward_name" type="text" class="form-control" v-model="extra_reward.name" />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group" v-bind:class="{ 'is-filled': true }">
                                        <label for="extra_reward_amount" class="bmd-label-floating">Valor Premiação Extra</label>
                                        <money id="extra_reward_amount" v-model="extra_reward.amount" maxlength="12" class="form-control" v-bind="money" placeholder=""></money>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="form.salesman_id != null">
                                <div class="col-md-10">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': extra_reward_2.name != ''}">
                                        <label for="extra_reward_name_2" class="bmd-label-floating">Descrição Premiação Extra</label>
                                        <input id="extra_reward_name_2" type="text" class="form-control" v-model="extra_reward_2.name" />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group" v-bind:class="{ 'is-filled': true }">
                                        <label for="extra_reward_amount_2" class="bmd-label-floating">Valor Premiação Extra</label>
                                        <money id="extra_reward_amount_2" v-model="extra_reward_2.amount" maxlength="12" class="form-control" v-bind="money" placeholder=""></money>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="form.salesman_id != null">
                                <div class="col-md-10">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': extra_reward_3.name != ''}">
                                        <label for="extra_reward_name_3" class="bmd-label-floating">Descrição Premiação Extra</label>
                                        <input id="extra_reward_name_3" type="text" class="form-control" v-model="extra_reward_3.name" />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group" v-bind:class="{ 'is-filled': true }">
                                        <label for="extra_reward_amount_3" class="bmd-label-floating">Valor Premiação Extra</label>
                                        <money id="extra_reward_amount_3" v-model="extra_reward_3.amount" maxlength="12" class="form-control" v-bind="money" placeholder=""></money>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="form.salesman_id != null">
                                <div class="col-md-10">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': chargeback.name != ''}">
                                        <label for="chargeback_name" class="bmd-label-floating">Descrição Estorno Retroativo</label>
                                        <input id="chargeback_name" type="text" class="form-control" v-model="chargeback.name" />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group" v-bind:class="{ 'is-filled': true }">
                                        <label for="chargeback_amount" class="bmd-label-floating">Valor Estorno Retroativo</label>
                                        <money id="chargeback_amount" v-model="chargeback.amount" maxlength="12" class="form-control" v-bind="money" placeholder=""></money>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="form.salesman_id != null">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': commission_rule_text != ''}">
                                        <label for="commission_rule_text" class="bmd-label-floating">Regra de Comissão</label>
                                        <textarea rows="5" id="commission_rule_text" type="text" class="form-control" v-model="commission_rule_text" />
                                    </div>
                                </div>
                            </div>
                            <div class="row"
                                v-if="form.type_profile_id.find(type_profile_id => type_profile_id.id == 4)">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="type_profile" class="bmd-label-floating">Perfil de Calculo de comissão</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="profiles"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.profile_id">
                                        </model-list-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Gerar</button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import TypeProfiles from '@/services/modules/typeprofiles.service';
    import Utils from '@/services/utils.service';
    import ExtraRewards from '@/services/modules/extra_rewards.service';

    export default {
        computed: {
            administrators: {
                get() {
                    return this.$store.state.administrators.itens;
                }
            },
            dates: {
                get() {
                    var dates = [
                        {id: 'sale_at', name: 'Data de Venda'},
                        {id: 'deployment_at', name: 'Data Alocação'},
                        {id: 'pay_at', name: 'Data de Pagamento'},
                        {id: 'pay_at-sale_at', name: 'Data de Pagamento (volume por data da venda)'},
                        {id: 'pay_at-sale_at_interval', name: 'Data de Pagamento (volume no intervalo filtrado)'},
                        {id: 'due_at', name: 'Data de Vencimento (apenas parcelas pagas)'},
                        {id: 'due_at-all', name: 'Data de Vencimento (parcelas pagas e não pagas)'},
                    ];

                    return dates;
                }
            },
            teams: {
                get() {
                    return this.$store.state.teams.itens;
                }
            }
        },
        data() {
            return {
                form: {
                    administrator_id: null,
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    date_by: 'sale_at',
                    type_profile_id: [],
                    profile_id: "",
                    team_id: null,
                    salesman_id: null
                },
                modalShow: false,
                profiles: [],
                salesmans: [],
                type_profiles: [],
                validation: {
                    date_at: null,
                    date_by: null,
                    type_profile_id: null
                },
                extra_reward: {
                    name: '',
                    amount: 0,
                },
                extra_reward_2: {
                    name: '',
                    amount: 0,
                },
                extra_reward_3: {
                    name: '',
                    amount: 0,
                },
                commission_rule_text: '',
                chargeback: {
                    name: '',
                    amount: 0,
                },
                money: {
                    decimal: ",",
                    thousands: ".",
                    prefix: "",
                    suffix: "",
                    precision: 2,
                    masked: false,
                },
            };
        },
        watch: {
            'form.date_at': function () {
                this.queryExtraReward();
            },
            'form.salesman_id': function () {
                this.queryExtraReward();
            },
        },
        methods: {
            async getDataProfile() {
                var self = this;
                self.$root.$emit("onLoading");
                const response = this.$store.dispatch("profiles/all");
                response.then(function(_profiles) {
                    self.profiles = _profiles.filter(profile => profile.type_profile_id == 4);
                    self.$root.$emit("onLoading");
                });
                response.catch(function() {
                    self.$root.$emit("onLoading");
                });
            },
            async getUsers(_param) {
                var self = this;

                self.$root.$emit('onLoading');

                const response =  self.$store.dispatch('users/all', _param);

                response.then(function (_salesmans) {
                    self.salesmans = _salesmans;
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            async getTeam(_id) {
                var self = this;

                self.$root.$emit('onLoading');

                const response =  self.$store.dispatch('teams/get', _id);

                response.then(function (_team) {
                    self.salesmans = _team.salesmans;
                    if (_team.supervisor && self.salesmans.some(_salesman => _salesman.id == _team.supervisor.id) == false) {
                        self.salesmans.push(_team.supervisor);
                    }
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            goBack() {
                var self = this;
                self.modalShow = false;
            },
            handlerChangeTeams(team_id) {
                this.getTeam(team_id);
            },
            handlerChangeSalesman(salesman_id) {
                var salesman = this.salesmans.find(_salesman => _salesman.id == salesman_id)
                if (salesman != undefined) {
                    this.form.profile_id = salesman.profile_id
                }
            },
            onPrint() {
                Utils.printWithoutScreen("printReport");
            },
            onReset() {
                alert("Reset");
            },
            async onSubmit() {
                var self = this;
                var form = self.form;
                var valid = true;
                var validation = self.validation;

                validation.date_at = null;
                validation.date_by = null;
                validation.type_profile_id = null;

                if (form.date_at[0] === null || form.date_at[1] === null) {
                    validation.date_at = "Favor informar o intervalo desejado!";
                    valid = false;
                }

                if (form.date_by === "") {
                    validation.date_by = "Favor selecionar a data desejada!";
                    valid = false;
                }

                if (form.type_profile_id.length === 0) {
                    validation.type_profile_id = "Favor selecionar ao menos um perfil!";
                    valid = false;
                }

                if (!valid) {
                    return;
                }

                if (form.salesman_id) {
                    await ExtraRewards.update({
                        date_start: Vue.moment(form.date_at[0]).format('YYYY-MM-DD'),
                        date_end: Vue.moment(form.date_at[1]).format('YYYY-MM-DD'),
                        salesman_id: form.salesman_id,
                        reward_name: self.extra_reward.name,
                        reward_amount: self.extra_reward.amount,
                        reward_name_2: self.extra_reward_2.name,
                        reward_amount_2: self.extra_reward_2.amount,
                        reward_name_3: self.extra_reward_3.name,
                        reward_amount_3: self.extra_reward_3.amount,
                        chargeback_name: self.chargeback.name,
                        chargeback_amount: self.chargeback.amount,
                        commission_rule_text: self.commission_rule_text,
                    });
                }

                var serialize = JSON.stringify(form);
                window.open("print-analytical-commission-by-profiles?form=" + serialize, '_blank');
            },
            async getDataAdministrators() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('administrators/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getDataTeams();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getDataTeams();
                });
            },
            async getDataProfiles() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = TypeProfiles.all();

                response.then(function (_profiles) {
                    self.type_profiles = _profiles.filter(profile => profile.id !== 1);
                    self.getDataAdministrators();
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    getDataAdministrators();
                    self.$root.$emit("onLoading");
                });
            },
            async getDataTeams() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getDataProfile();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getDataProfile();
                });
            },
            async queryExtraReward() {
                const self = this;
                const response = await ExtraRewards.query({
                    date_start: Vue.moment(self.form.date_at[0]).format('YYYY-MM-DD'),
                    date_end: Vue.moment(self.form.date_at[1]).format('YYYY-MM-DD'),
                    salesman_id: self.form.salesman_id,
                });
                if (response.length == 0) {
                   self.extra_reward.name = '';
                   self.extra_reward.amount = 0;
                   self.extra_reward_2.name = '';
                   self.extra_reward_2.amount = 0;
                   self.extra_reward_3.name = '';
                   self.extra_reward_3.amount = 0;
                   self.chargeback.name = '';
                   self.chargeback.amount = 0;
                   self.commission_rule_text = '';
                   return;
                }
                self.extra_reward.name = response[0].reward_name;
                self.extra_reward.amount = response[0].reward_amount;
                self.extra_reward_2.name = response[0].reward_name_2;
                self.extra_reward_2.amount = response[0].reward_amount_2;
                self.extra_reward_3.name = response[0].reward_name_3;
                self.extra_reward_3.amount = response[0].reward_amount_3;
                self.chargeback.name = response[0].chargeback_name;
                self.chargeback.amount = response[0].chargeback_amount;
                self.commission_rule_text = response[0].commission_rule_text;
            },
        },
        mounted() {
            var self = this;

            self.getDataProfiles();

            setTimeout(() => {
                self.administrators.unshift(
                        {
                            id: '',
                            name: 'Todas'
                        }
                );
            }, 1000);

            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });
        }
    }
</script>
